import React from "react";
import Flags from "Assets/png/flags.png";
import "react-telephone-input/css/default.css";
import "./PhoneNumberDropdown.scss";

const CountryFlag = ({ country }) => {
  if (!country || !country.iso2) return null;

  return (
    <div className="react-tel-input">
      <div
        className={`flag ${country.iso2.toLowerCase()}`}
        style={{ backgroundImage: `url(${Flags})` }}
      ></div>
    </div>
  );
};

const PhoneNumberDropdown = ({ phoneNumbers, selectedNumber, onSelect, onClose }) => {
  return (
    <>
      <div className="phoneNumberDropdown">
        <ul className="phoneNumberList">
          {phoneNumbers.map((item, index) => {
            const isSelected = item.value === selectedNumber;
            return (
              <li
                key={`phone-${index}`}
                className={`phoneNumberItem ${isSelected ? "selected" : ""}`}
                onClick={() => {
                  onSelect(item);
                  onClose();
                }}
              >
                <span className="radioButton">
                  <i className="material-icons">
                    {isSelected ? "radio_button_checked" : "radio_button_unchecked"}
                  </i>
                </span>
                {item.country && <CountryFlag country={item.country} />}
                <span className="phoneNumber">{item.value}</span>
              </li>
            );
          })}
        </ul>
      </div>
      <div className="phoneNumberDropdownOverlay" onClick={onClose} />
    </>
  );
};

export default PhoneNumberDropdown;

